// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestTags-cls1_Vr5","cls2":"ResearchInterestTags-cls2_t_u ResearchInterestTags-cls1_Vr5"};